import { ReactComponent as Logo } from '../assets/images/logo.svg';
import { ReactComponent as LogoUkr } from '../assets/images/logo-ukrzoloto.svg';
import { UkrZolotoBrandName} from '../helpers/helpers';

function Header({ brandName }) {
    if (brandName === '') return null;

    const logo = brandName === UkrZolotoBrandName ? <LogoUkr className='logo' /> : <Logo className='logo' />;
    const headerStyle = {
        backgroundColor: brandName === UkrZolotoBrandName ? '#00502F' : '#372924'
    }
    return (
        <>
            <div className='header' style={headerStyle}>
                {logo}
            </div>
        </>
    )
}

export default Header;
